import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../../store/aboutUs.js'), 'aboutUs.js')
  resolveStoreModules(require('../../store/academicCourses.js'), 'academicCourses.js')
  resolveStoreModules(require('../../store/account.js'), 'account.js')
  resolveStoreModules(require('../../store/ads.js'), 'ads.js')
  resolveStoreModules(require('../../store/articles.js'), 'articles.js')
  resolveStoreModules(require('../../store/articleTags.js'), 'articleTags.js')
  resolveStoreModules(require('../../store/boards.js'), 'boards.js')
  resolveStoreModules(require('../../store/campuses.js'), 'campuses.js')
  resolveStoreModules(require('../../store/cart.js'), 'cart.js')
  resolveStoreModules(require('../../store/checkout.js'), 'checkout.js')
  resolveStoreModules(require('../../store/comments.js'), 'comments.js')
  resolveStoreModules(require('../../store/contents.js'), 'contents.js')
  resolveStoreModules(require('../../store/creditCards.js'), 'creditCards.js')
  resolveStoreModules(require('../../store/events.js'), 'events.js')
  resolveStoreModules(require('../../store/files.js'), 'files.js')
  resolveStoreModules(require('../../store/footerColumns.js'), 'footerColumns.js')
  resolveStoreModules(require('../../store/forms.js'), 'forms.js')
  resolveStoreModules(require('../../store/homepages.js'), 'homepages.js')
  resolveStoreModules(require('../../store/loanProducts.js'), 'loanProducts.js')
  resolveStoreModules(require('../../store/loans.js'), 'loans.js')
  resolveStoreModules(require('../../store/loanShops.js'), 'loanShops.js')
  resolveStoreModules(require('../../store/marathons.js'), 'marathons.js')
  resolveStoreModules(require('../../store/media.js'), 'media.js')
  resolveStoreModules(require('../../store/modals.js'), 'modals.js')
  resolveStoreModules(require('../../store/orders.js'), 'orders.js')
  resolveStoreModules(require('../../store/pages.js'), 'pages.js')
  resolveStoreModules(require('../../store/posts.js'), 'posts.js')
  resolveStoreModules(require('../../store/products.js'), 'products.js')
  resolveStoreModules(require('../../store/productVariants.js'), 'productVariants.js')
  resolveStoreModules(require('../../store/requests.js'), 'requests.js')
  resolveStoreModules(require('../../store/roles.js'), 'roles.js')
  resolveStoreModules(require('../../store/scripts.js'), 'scripts.js')
  resolveStoreModules(require('../../store/search.js'), 'search.js')
  resolveStoreModules(require('../../store/settings.js'), 'settings.js')
  resolveStoreModules(require('../../store/shops.js'), 'shops.js')
  resolveStoreModules(require('../../store/termsOfUse.js'), 'termsOfUse.js')
  resolveStoreModules(require('../../store/transparency.js'), 'transparency.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
